import { Button, Divider, Tag } from "antd";
import { ImageWrapper } from "../../components/image/ImageViewer";
import { PENDING, STATUS_RESOLVED } from "../../constants/webapp";
import { ActionsUpdate, getTicketStatus } from "../../hooks/tickets/useTickets";
import { dateTimeFormat } from "../../utils/formatter";

export const TicketDetails = ({ data }) => {
  const { topic, email, timestamp, status, description, imageUrls, id } =
    data || {};

  const ticketData = [
    {
      title: "Topic",
      subtitle: topic,
    },
    {
      title: "Description",
      subtitle: description,
    },
    {
      title: "Email",
      subtitle: email,
    },
    {
      title: "Date Submitted",
      subtitle: dateTimeFormat(timestamp),
    },
    {
      title: "Ticket Number",
      subtitle: `#${id}`,
    },
  ];

  return (
    <div>
      <div className="flexSpaceCenter">
        <Button
          onClick={() =>
            ActionsUpdate(data, {
              status: status === PENDING ? STATUS_RESOLVED : PENDING,
            })
          }
        >
          Mark as Resolved
        </Button>
        <Tag style={{ margin: 0 }} color={getTicketStatus(status).color}>
          {getTicketStatus(status).status}
        </Tag>
      </div>
      <Divider />

      {ticketData.map(({ title, subtitle }) => (
        <div>
          <h3 style={{ marginBottom: 5 }}>{title}</h3>
          <p>{subtitle}</p>
          <Divider />
        </div>
      ))}

      {imageUrls?.length > 0 && (
        <>
          <h3 style={{ marginBottom: 10 }}>Screenshots</h3>
          <ImageWrapper images={imageUrls} />
        </>
      )}
    </div>
  );
};
